<ng-container *ngIf="!isLoading; else loading">
  <dgx-not-found
    [descriptionText]="i18n.Opportunities_NotFound_DescriptionText"
    [headerText]="i18n.Core_NotFound_HeaderText"
    [navigationText]="i18n.Opportunities_BrowseOpportunities"
    [navigationUrl]="navigationUrl"
  ></dgx-not-found>
</ng-container>
<ng-template #loading>
  <!-- TODO: replace spinner with skeleton loaders -->
  <div class="guts-p-t-4 stretch">
    <df-spinner></df-spinner>
  </div>
</ng-template>
